import styled, { css } from 'styled-components';
import { prop } from 'ramda';

import { Color, Layer } from '../../../../theme';
import { hexToRgba, styleWhenTrue } from '../../../../utils';

import { VideoPopupContainerData, CoverContainerData } from './videoPlayer.types';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const CoverContainer = styled.div<CoverContainerData>`
  background: url(${(props: CoverContainerData) => props.background});
  height: 100%;
  width: 100%;
  padding: 0;
  position: relative;
`;

export const PlayButtonContainer = styled.button`
  border-radius: 50%;
  background-color: ${hexToRgba(Color.black, 0.3)};
  height: 95px;
  width: 95px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PlayButton = styled.img`
  height: 29px;
`;

export const Label = styled.div`
  color: ${Color.white};
  font-size: 20px;
  letter-spacing: 0.2px;
  line-height: 25px;
  position: absolute;
  bottom: 30px;
  left: 30px;
`;

export const VideoPopupContainer = styled.div<VideoPopupContainerData>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${hexToRgba(Color.black, 0.3)};
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.7s;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: ${Layer.VideoPopup};
  ${styleWhenTrue(prop('isVisible'), css`
    pointer-events: initial;
    opacity: 1;
  `)}
`;

export const VideoPopup = styled.div`
  height: 75%;
  width: 75%;
  background-color: ${Color.black};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Video = styled.iframe`
  width: 100%;
  height: 100%;
`;

export const ImageShadowContainer = styled.div`
  height: 100%;
  width: 100%;
  background: ${hexToRgba(Color.black, 0.15)};
`;

export const LabelShadowContainer = styled.div`
  height: 100%;
  width: 100%;
  background-image: linear-gradient(180deg, ${hexToRgba(Color.black, 0.01)} 56%, ${hexToRgba(Color.black, 0.25)} 96%);
  display: flex;
  justify-content: center;
  align-items: center;
`;
